/**
 * Formatea un número de DNI con puntos separadores de miles (formato argentino)
 * @param value - El valor a formatear (solo números)
 * @returns El valor formateado con puntos (ej: "12.345.678")
 */
export const formatDNI = (value: string): string => {
    // Remover todo excepto dígitos
    const numbers = value.replace(/\D/g, '');

    // Agregar puntos cada 3 dígitos desde la derecha
    return numbers.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Handler para el evento onChange del campo DNI
 * Formatea el valor automáticamente mientras el usuario escribe
 * @param event - El evento de cambio del input
 * @returns El evento modificado con el valor formateado
 */
export const handleDNIChange = (event: React.ChangeEvent<HTMLInputElement>): string => {
    const formattedValue = formatDNI(event.target.value);
    event.target.value = formattedValue;
    return formattedValue;
};

/**
 * Hook personalizado para manejar el campo DNI con formateo automático
 * @param initialValue - Valor inicial del campo (opcional)
 * @returns Objeto con el valor formateado y el handler onChange
 */
export const useDNIField = (initialValue = '') => {
    const [value, setValue] = React.useState(formatDNI(initialValue));

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const formattedValue = handleDNIChange(event);
        setValue(formattedValue);
    };

    return {
        value,
        onChange,
        getValueWithoutDots: () => value.replace(/\./g, ''),
    };
};

import React from 'react';
